import QRToyota from "../../../../components/shared/QRToyota";

export default function DocumentCust({ customer, pageno, pages }: any) {
  return (
    <div className="flex flex-row justify-between items-center border border-black  text-xs">
      <div className="pl-4 py-2">
        <span className="text-lg font-bold">{customer?.customer_name}</span>
        <br />
        {customer?.address1 ? customer?.address1 : "-"}
        <br />
        {customer?.address2 ? customer?.address2 : "-"} <br />
        {customer?.address3 ? customer?.address3 : "-"} <br />
        {customer?.address4 ? customer?.address4 : "-"}
        <br />
        {customer?.address5 ? customer?.address5 : "-"}
      </div>
      <div className="flex -ml-24">
        <div className="flex flex-row text-center">
          <div className="">Page </div>
          <div className="ml-1">
            {pageno} / {pages}
          </div>
        </div>
      </div>
      <div className="">
        <QRToyota value={`${customer?._id}`} size={95} />
      </div>
    </div>
  );
}
